import { render } from "./FPluginPermissionrecord.vue?vue&type=template&id=0e737b51&scoped=true"
import script from "./FPluginPermissionrecord.vue?vue&type=script&lang=js"
export * from "./FPluginPermissionrecord.vue?vue&type=script&lang=js"

import "./FPluginPermissionrecord.vue?vue&type=style&index=0&id=0e737b51&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e737b51"]])

export default __exports__